import React from 'react';
import {Form, Select} from 'semantic-ui-react';

const SearchForm = ({
  statusSelect,
  handleChange,
  status,
}) => {
  return (
    <React.Fragment>
      <Form.Field
        control={Select}
        options={statusSelect}
        label='Estado'
        placeholder='Estado'
        value={status}
        onChange={(e, {value}) => handleChange('status', value)}
      />
    </React.Fragment>
  );
};

export default SearchForm;
